<template>
    <v-card flat outlined tile>
        <section-header title="Stories" :action="true" :small="true" class="pl-4 pr-0 py-2"></section-header>
        <infinite-scroller-vertical @scrolledTillBottom="scrolledTillBottom" style="height: 20vh;min-height: 100px" :windowTarget="false">
            <template>
                <v-list>
                    <v-list-item two-line @click="profile" v-for="(n,index) in listItems" :key="'stor-' + index">
                        <v-list-item-avatar color="blue" class="v-avatar--badge">
                            <v-badge color="purple" overlap right>
                                <template v-slot:badge>
                                    <span>5</span>
                                </template>
                                <v-avatar size="36">
                                    <span class="white--text headline">A</span>
                                </v-avatar>
                            </v-badge>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>Arun</v-list-item-title>
                            <v-list-item-subtitle class="caption">23 hrs ago</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>
        </infinite-scroller-vertical>
    </v-card>
</template>
<script>
export default {
    data: () => ({
        listItems: 10
    }),
    methods: {
        profile() {},

        scrolledTillBottom(val) {
            if (val) {
                this.listItems += 10
            }
        }
    }
}
</script>